import { motion } from "framer-motion";

const stats = [
  { value: "15+", label: "Years in Taxation" },
  { value: "7+", label: "Years post CA Qualification" },
  { value: "1800+", label: "Tax Queries Resolved" },
  { value: "1000+", label: "CA Students Mentored" },
];

export const About = () => {
  return (
    <section id="about" data-testid="about-section" className="relative section-pad overflow-hidden">
      <div className="shape-blob w-[420px] h-[420px] -left-32 top-1/2 opacity-30"
           style={{ background: "radial-gradient(circle, #16D1C8 0%, transparent 70%)" }} />
      <div className="shape-blob w-[420px] h-[420px] -right-40 top-20 opacity-30"
           style={{ background: "radial-gradient(circle, #FF2D7A 0%, transparent 70%)" }} />

      <div className="container-x relative z-10">
        <div className="grid lg:grid-cols-[1fr,1.2fr] gap-14 items-start">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6 }}
          >
            <div className="label-eyebrow mb-5">About me</div>
            <h2 data-testid="about-title" className="font-heading font-bold text-4xl md:text-5xl lg:text-6xl leading-[1.05]">
              The story behind <br /><span className="gradient-text-cool">the practice.</span>
            </h2>
            <p className="mt-6 text-white/65 leading-relaxed">
              I have lived this profession from every angle — practice, technology, and teaching.
              And one thing has stayed constant: <span className="text-white">tax is never just numbers.</span>
            </p>
            <p className="mt-4 text-white/65 leading-relaxed">
              The financial world is divided into two types of people: those who react to tax notices,
              and those who architect their financial future. I build systems that help you do the latter.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.7, delay: 0.1 }}
            className="grid grid-cols-2 gap-5"
            data-testid="about-stats"
          >
            {stats.map((s, i) => (
              <div
                key={s.label}
                data-testid={`stat-${i}`}
                className="glass p-7 hover:-translate-y-1 transition-transform duration-500 group relative overflow-hidden"
              >
                <div className="absolute -top-10 -right-10 w-32 h-32 rounded-full opacity-0 group-hover:opacity-30 transition-opacity duration-500"
                     style={{ background: i % 2 === 0 ? "radial-gradient(circle, #16D1C8, transparent)" : "radial-gradient(circle, #FF2D7A, transparent)" }} />
                <div className="font-heading font-bold text-5xl md:text-6xl gradient-text">
                  {s.value}
                </div>
                <div className="mt-2 text-sm text-white/65 leading-snug">{s.label}</div>
              </div>
            ))}
            <div className="col-span-2 glass p-7 flex items-start gap-4">
              <div className="w-14 h-14 shrink-0 rounded-2xl overflow-hidden bg-black ring-1 ring-white/10">
                <img
                  src="https://customer-assets.emergentagent.com/job_shivangi-digital/artifacts/z1cbny6n_619e7a1a0cf2c56a71b570e2.png"
                  alt="Shivangi Mittal Logo"
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <div className="text-white font-medium">Practicing CA · Founder · Faculty</div>
                <div className="mt-1 text-sm text-white/60 leading-relaxed">
                  My work sits at the intersection of <span className="text-teal-300">Tax Practice</span>,{" "}
                  <span className="text-magenta-500">Technology</span> &{" "}
                  <span className="text-neon-orange">Faculty</span> — built around outcomes, not opinions.
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
